import { KalturaAssetStruct, KalturaMeta } from '@kaltura-ott/ott-client-types/api/types';

import { CATEGORY_ID_SYSTEM_NAME, KUX_FEATURE_NAME, MAIN_VIRTUAL_ASSET_STRUCT_NAME } from './constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const filterByKUXPrefix = (data: any) => {
  const filteredObjects = data.objects.filter(
    (obj: KalturaMeta | KalturaAssetStruct) =>
      obj.features.indexOf(KUX_FEATURE_NAME) != -1 ||
      obj.systemName === CATEGORY_ID_SYSTEM_NAME ||
      obj.systemName === MAIN_VIRTUAL_ASSET_STRUCT_NAME,
  );
  data.objects = filteredObjects;
  data.totalCount = filteredObjects.length;
  return data;
};
